import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import {
  Grid,
  Typography,
  TextField,
  FormControlLabel,
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  Radio,
  FormLabel,
  RadioGroup,
  MenuItem,
  Paper,
  FormGroup,
  Card,
  CardHeader,
  CardActions,
  CardContent,
  FormHelperText,
} from "@mui/material";

import Autocomplete from '@mui/material/Autocomplete';

import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import Constants from "../../../services/Constants";
import NextPrevBtn from "../../../services/NextPrevBtn";
import * as Service from "../../../services/Service.js";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const ProductFormData = ({
  errorObject,
  addProductForm,
  formData,
  handleChange,
  handleCheck,
  handleReset,
  handleSubmit,
  handleUpdate,
  ValidateProductForDispensing,
  handleATCChange,
  ...props
}) => {
  const StockData = JSON.parse(localStorage.getItem("ProductDataNextPrev"));

  const StockDataIndex = JSON.parse(localStorage.getItem("ProductDataIndex"));

  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "products";

  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = useState(0);
  const { t, i18n } = useTranslation();

  const GenericList = JSON.parse(localStorage.getItem("GenericList"));
  const Strengthlist = JSON.parse(localStorage.getItem("Strengthlist"));
  const DosageFormlist = JSON.parse(localStorage.getItem("DosageFormlist"));
  const PackSizelist = JSON.parse(localStorage.getItem("PackSizelist"));
  const Unitofmeasurelist = JSON.parse(
    localStorage.getItem("Unitofmeasurelist")
  );
  const RouteOfAdminlist = JSON.parse(localStorage.getItem("RouteOfAdminlist"));
  const VEN_List = JSON.parse(localStorage.getItem("VEN_List"));
  const ProductGroupList = JSON.parse(localStorage.getItem("ProductGroupList"));
  const ABC_List = JSON.parse(localStorage.getItem("ABC_List"));
  const RxLevelList = JSON.parse(localStorage.getItem("RxLevelList"));
  const ATC_List = JSON.parse(localStorage.getItem("ATC_List"));
  const [ProductSubGroupList, setProductSubGroupListLocal] = useState([]);
  // const ProductTypeLocal = JSON.parse(localStorage.getItem("ProductTypeId"));

  //  const [atcDefaultValue, setAtcDefaultValue] = useState(ATC_List[defaultATCIndex]);
  // const atcDefaultValue = ATC_List[defaultATCIndex];
  // console.log('atcDefaultValuesssssss: ', atcDefaultValue);
  //  console.log('ATC_List[defaultATCIndex]: ', ATC_List[defaultATCIndex]);

  //====== Start Choosen Dropdown===========
  const [chosenValues, setChosenValues] = useState({
    genericName: null,
    strengthSize: null,
    form: null,
    routeOfAdmin: null,
    packSize: null,
    unit: null,
    administrationUnit: null,
  });

  useEffect(() => {
    const findOrNull = (list, id) =>
      list.find((item) => item.id == id) ?? null;

    setChosenValues({
      genericName: findOrNull(GenericList, formData.genericName),
      strengthSize: findOrNull(Strengthlist, formData.strengthSize),
      form: findOrNull(DosageFormlist, formData.form),
      routeOfAdmin: findOrNull(RouteOfAdminlist, formData.routeOfAdmin),
      packSize: findOrNull(PackSizelist, formData.packSize),
      unit: findOrNull(Unitofmeasurelist, formData.unit),
      administrationUnit: findOrNull(Unitofmeasurelist, formData.administrationUnit),
    });
  }, [
    formData.genericName,
    formData.strengthSize,
    formData.form,
    formData.routeOfAdmin,
    formData.packSize,
    formData.unit,
    formData.administrationUnit,
  ]);

  const handleChangeChoosen = (name, valueobj, value) => {
    let chosenValuesData = { ...chosenValues };
    chosenValuesData[name] = valueobj;
    setChosenValues(chosenValuesData);
    props.handleChangeChoosenProps(name, value);
  };

  //====== End Choosen Dropdown===========

  const ProductTypeList = [
    { id: "None", name: DispensingLanguage[lan][menukey]["None"] },
    { id: "TLD", name: "TLD" },
    { id: "TLE", name: "TLE" },
  ];

  function tabChangeHandler(event, newValue) {
    setValue(newValue);
  }

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const getPricebesideLevel = (type = null) => {
    let level = "";
    let extraString = "";
    if (type == "shippingPack") {
      extraString = "x ";
    } else {
      extraString = "/ ";
    }

    if (formData.packSize && formData.unit) {
      let packSizes = PackSizelist;
      let selectedPackSize = packSizes.find(
        (packSize) => packSize.id == formData.packSize
      );

      let units = Unitofmeasurelist;
      let selectedUnit = units.find((unit) => unit.id == formData.unit);
      level = extraString + selectedPackSize.name + " " + selectedUnit.name;
    }
    return level;
  };

  const handleIndex = (indx, row) => {
    localStorage.setItem("ProductDataIndex", JSON.stringify(indx));
    let route = `${row.id}`;
    props.history.push(route);
  };

  const handleProductGroupChange = (event) => {
    formData["ItemGroupId"] = event.target.value;
    formData["ProductTypeId"] = 0;
    cProductSubGroupList();
    props.handleChangeProductGroupProps(event.target.value);
  };

  function cProductSubGroupList() {
    let ZoneParam = {
      action: "ProductSubGroupList",
      ItemGroupId: formData["ItemGroupId"],
      menukey: "",
    };
    Service.default
      .postApi("source/combo_generic.php", ZoneParam)
      .then((res) => {
        setProductSubGroupListLocal(res.datalist);
      })
      .catch((err) => {});
  }

  React.useEffect(() => {
    //console.log('formData--------', formData);
    if (!addProductForm) {
      cProductSubGroupList();
    }
  }, [formData]);

  return (
    <div className={classes.productPageTitle}>
      <div className="sw_makeStyles_tableContainer">
        <div className="d-flex justify-product">
          <Grid container>
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading">
              <div className="sw_heading_title">
                {DispensingLanguage[lan][menukey]["Product Entry"]} -{" "}
                {addProductForm
                  ? DispensingLanguage[lan][menukey]["Add"]
                  : DispensingLanguage[lan][menukey]["Edit"]}
              </div>

              <div className="float-end sw_btn_control">
                {addProductForm ? (
                  <Grid item xs={12} className="text-center">
                    <div className="float-end sw_btn_control">
                      <Button
                        disabled={!!props.permissionType}
                        className="me-2"
                        variant="contained"
                        color="gray"
                        type="reset"
                        onClick={() => handleReset()}
                      >
                        {DispensingLanguage[lan][menukey]["Reset"]}
                      </Button>
                      <Button
                        disabled={!!props.permissionType}
                        className="me-2"
                        variant="contained"
                        color="primary"
                        onClick={() => handleSubmit()}
                      >
                        {DispensingLanguage[lan][menukey]["Save"]}
                      </Button>
                      <Button
                        className="me-2"
                        variant="contained"
                        color="gray"
                        type="reset"
                        onClick={() => props.history.push("/products")}
                      >
                        {DispensingLanguage[lan][menukey]["Back to List"]}
                      </Button>
                    </div>
                  </Grid>
                ) : (
                  <Grid item xs={12} className="text-center">
                    <Button
                      disabled={!!props.permissionType}
                      className="me-2"
                      variant="contained"
                      color="primary"
                      onClick={() => handleUpdate()}
                    >
                      {DispensingLanguage[lan][menukey]["Update"]}
                    </Button>

                    <Button
                      className="me-2"
                      variant="contained"
                      color="gray"
                      type="reset"
                      onClick={() => props.history.push("/products")}
                    >
                      {DispensingLanguage[lan][menukey]["Back to List"]}
                    </Button>
                  </Grid>
                )}
              </div>
            </div>
          </Grid>
          </Grid>
        </div>

        {addProductForm ? (
          <></>
        ) : (
          <NextPrevBtn
            dataList={StockData}
            StockDataIndex={StockDataIndex}
            handleReset={handleReset}
            handleIndex={handleIndex}
            {...props}
          />
        )}

        {/* New row */}

        <Grid container spacing={3}>
          <Grid item xs={6} sm={2}>
            <FormControl variant="standard" className={classes.fullWidth}>
              <InputLabel id="demo-simple-select-helper-label">
                {DispensingLanguage[lan][menukey]["Product Group"]}*
              </InputLabel>
              <Select
                error={!!errorObject.ItemGroupId}
                labelId="demo-simple-select-helper-label"
                id="demo-simple-select-helper"
                name="ItemGroupId"
                disabled={
                  props.permissionType || (addProductForm ? false : true)
                }
                value={formData.ItemGroupId}
                fullWidth
                onChange={(e) => handleProductGroupChange(e)}
              label={`${DispensingLanguage[lan][menukey]["Product Group"]} *`}>
                {ProductGroupList.map((item, index) => {
                  return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                })}
              </Select>
              <FormHelperText error={!!errorObject.ItemGroupId}>
                {errorObject.ItemGroupId}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={6} sm={3}>
            <FormControl variant="standard" className={classes.fullWidth}>
              <InputLabel id="demo-simple-select-helper-label">
                {DispensingLanguage[lan][menukey]["Product Type"]}*
              </InputLabel>
              <Select
                disabled={!!props.permissionType}
                error={!!errorObject.ProductTypeId}
                labelId="demo-simple-select-helper-label"
                id="ProductTypeId"
                name="ProductTypeId"
                // value={formData.ProductTypeId}
                value={formData.ProductTypeId}
                fullWidth
                onChange={(e) => handleChange(e)}
              label={`${DispensingLanguage[lan][menukey]["Product Type"]} *`}>
                <MenuItem value="0">
                  {DispensingLanguage[lan][menukey]["Select Product Type"]}
                </MenuItem>

                {ProductSubGroupList.map((item, index) => {
                  return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                })}
              </Select>
              <FormHelperText error={!!errorObject.ProductTypeId}>
                {errorObject.ProductTypeId}
              </FormHelperText>
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          <Grid item xs={4} sm={7}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={3}>
                <TextField variant="standard"
                  disabled={!!props.permissionType}
                  error={!!errorObject.productCode}
                  helperText={errorObject.productCode}
                  required
                  id="productCode"
                  name="productCode"
                  label={DispensingLanguage[lan][menukey]["Product Code"]}
                  value={formData.productCode}
                  fullWidth
                  //disabled={true}
                  autoComplete="family-name"
                  onChange={(e) => handleChange(e)}
                />
              </Grid>

              <Grid item xs={12} sm={9}>
                <TextField variant="standard"
                  required
                  id="productName"
                  name="productName"
                  label={DispensingLanguage[lan][menukey]["Product Name"]}
                  value={formData.productName}
                  fullWidth
                  //disabled={formData.ItemGroupId === 3?true:false}
                  disabled={formData.ItemGroupId != 12}
                  autoComplete="given-name"
                  onChange={(e) => handleChange(e)}
                />
                <TextField variant="standard"
                  hidden
                  id="ItemShortName"
                  name="ItemShortName"
                  label="Item Short Name"
                  value={formData.ItemShortName}
                  fullWidth
                  disabled={true}
                  autoComplete="given-name"
                  onChange={(e) => handleChange(e)}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={4} sm={3}>
            <TextField variant="standard"
              disabled={!!props.permissionType}
              error={!!errorObject.ShortName}
              helperText={errorObject.ShortName}
              required
              id="ShortName"
              name="ShortName"
              label={DispensingLanguage[lan][menukey]["Product Short Name"]}
              value={formData.ShortName}
              fullWidth
              autoComplete="given-name"
              onChange={(e) => handleChange(e)}
            />
          </Grid>

          <Grid item xs={2} sm={2}>
            <FormControl variant="standard" className={classes.fullWidth}>
              <InputLabel id="demo-simple-select-helper-label">
                {DispensingLanguage[lan][menukey]["VEN"]}
              </InputLabel>
              <Select
                disabled={!!props.permissionType}
                labelId="demo-simple-select-helper-label"
                id="demo-simple-select-helper"
                name="ven"
                value={formData.ven}
                fullWidth
                onChange={(e) => handleChange(e)}
              label={DispensingLanguage[lan][menukey]["VEN"]}>
                {VEN_List.map((item, index) => {
                  return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                })}
              </Select>
            </FormControl>
          </Grid>

          {/* New row */}
          <Grid item xs={4} sm={3}>
            <TextField variant="standard"
              disabled={!!props.permissionType}
              required
              id="icn"
              name="icn"
              label={DispensingLanguage[lan][menukey]["ICN"]}
              value={formData.icn}
              // disabled={true}
              fullWidth
              autoComplete="given-name"
              onChange={(e) => handleChange(e)}
            />
          </Grid>
          <Grid item xs={4} sm={3}>
            <FormControl className={classes.fullWidth}>
              <Autocomplete
                autoHighlight
                disabled={!!props.permissionType}
                id="genericName"
                options={GenericList}
                onChange={(event, valueobj) =>
                  handleChangeChoosen(
                    "genericName",
                    valueobj,
                    valueobj ? valueobj.id : ""
                  )
                }
                getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                value={chosenValues["genericName"]}
                renderOption={(props, option) => (
                  <li {...props} key={option.id ?? option.name}>
                    <Typography className="sw_fontSize">{option.name}</Typography>
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    value={formData.genericName}
                    label={
                      DispensingLanguage[lan][menukey]["Generic Name"] + " *"
                    }
                    variant="standard"
                    error={!!errorObject.genericName}
                    helperText={errorObject.genericName}
                    id="genericName"
                    name="genericName"
                    fullWidth
                  />
                )}
              />
            </FormControl>
          </Grid>
          <Grid item xs={4} sm={3}>
            <TextField variant="standard"
              disabled={!!props.permissionType}
              id="tradeName"
              name="tradeName"
              label={
                DispensingLanguage[lan][menukey]["Trade Name or Other Name"]
              }
              value={formData.tradeName}
              fullWidth
              autoComplete="given-name"
              onChange={(e) => handleChange(e)}
            />
          </Grid>

          <Grid item xs={4} sm={3}>
            <Grid container spacing={3}>
              <Grid item xs={6} sm={6}>
                <FormControl variant="standard" className={classes.fullWidth}>
                  <InputLabel id="demo-simple-select-helper-label">
                    {DispensingLanguage[lan][menukey]["Rx Level"]}
                  </InputLabel>
                  <Select
                    disabled={!!props.permissionType}
                    labelId="demo-simple-select-helper-label"
                    id="demo-simple-select-helper"
                    name="rxLevel"
                    value={formData.rxLevel}
                    fullWidth
                    onChange={(e) => handleChange(e)}
                  label={DispensingLanguage[lan][menukey]["Rx Level"]}>
                    {RxLevelList.map((item, index) => {
                      return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6} sm={6}>
                <FormControl variant="standard" className={classes.fullWidth}>
                  <InputLabel id="demo-simple-select-helper-label">
                    {DispensingLanguage[lan][menukey]["ABC"]}
                  </InputLabel>
                  <Select
                    disabled={!!props.permissionType}
                    labelId="demo-simple-select-helper-label"
                    id="demo-simple-select-helper"
                    name="abc"
                    value={formData.abc}
                    fullWidth
                    onChange={(e) => handleChange(e)}
                  label={DispensingLanguage[lan][menukey]["ABC"]}>
                    {ABC_List.map((item, index) => {
                      return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>

          {/* New row */}
          <Grid item xs={4} sm={3}>
            <TextField variant="standard"
              disabled={!!props.permissionType}
              id="ecn"
              name="ecn"
              label={DispensingLanguage[lan][menukey]["ECN"]}
              value={formData.ecn}
              fullWidth
              autoComplete="given-name"
              onChange={(e) => handleChange(e)}
            />
          </Grid>

          <Grid item xs={4} sm={3}>
            <FormControl className={classes.fullWidth}>
              <Autocomplete
                autoHighlight
                disabled={!!props.permissionType}
                id="strengthSize"
                options={Strengthlist}
                onChange={(event, valueobj) =>
                  handleChangeChoosen(
                    "strengthSize",
                    valueobj,
                    valueobj ? valueobj.id : ""
                  )
                }
                getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                value={chosenValues["strengthSize"]}
                renderOption={(props, option) => (
                  <li {...props} key={option.id ?? option.name}>
                    <Typography className="sw_fontSize">{option.name}</Typography>
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    value={formData.strengthSize}
                    label={
                      DispensingLanguage[lan][menukey]["Strength/Size"] + " *"
                    }
                    variant="standard"
                    error={!!errorObject.strengthSize}
                    helperText={errorObject.strengthSize}
                    id="strengthSize"
                    name="strengthSize"
                    fullWidth
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={4} sm={3}>
            <div className="sw_overlay_text">
              <TextField variant="standard"
                disabled={!!props.permissionType}
                id="price"
                name="price"
                type="number"
                label={DispensingLanguage[lan][menukey]["Price (CFA)"]}
                value={formData.price}
                fullWidth
                autoComplete="shipping address-level2"
                onChange={(e) => handleChange(e)}
              />{" "}
              <span className="sw_pack_size">{getPricebesideLevel()}</span>
            </div>
          </Grid>

          <Grid item xs={4} sm={3}>
            <TextField variant="standard"
              disabled={!!props.permissionType}
              id="binLocation"
              name="binLocation"
              label={DispensingLanguage[lan][menukey]["Bin Location"]}
              value={formData.binLocation}
              fullWidth
              autoComplete="given-name"
              onChange={(e) => handleChange(e)}
            />
          </Grid>

          {/* New row */}
          <Grid item xs={4} sm={3}>
            <TextField variant="standard"
              disabled={!!props.permissionType}
              id="nsn"
              name="nsn"
              label={DispensingLanguage[lan][menukey]["NSN"]}
              value={formData.nsn}
              fullWidth
              autoComplete="given-name"
              onChange={(e) => handleChange(e)}
            />
          </Grid>

          <Grid item xs={4} sm={3}>
            <FormControl className={classes.fullWidth}>
              <Autocomplete
                autoHighlight
                disabled={!!props.permissionType}
                id="form"
                options={DosageFormlist}
                onChange={(event, valueobj) =>
                  handleChangeChoosen(
                    "form",
                    valueobj,
                    valueobj ? valueobj.id : ""
                  )
                }
                getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                value={chosenValues["form"]}
                renderOption={(props, option) => (
                  <li {...props} key={option.id ?? option.name}>
                    <Typography className="sw_fontSize">{option.name}</Typography>
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    value={formData.form}
                    label={DispensingLanguage[lan][menukey]["Form"] + " *"}
                    variant="standard"
                    error={!!errorObject.form}
                    helperText={errorObject.form}
                    id="form"
                    name="form"
                    fullWidth
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={4} sm={3}>
            <FormControl className={classes.fullWidth}>
              <Autocomplete
                autoHighlight
                disabled={!!props.permissionType}
                id="routeOfAdmin"
                options={RouteOfAdminlist}
                onChange={(event, valueobj) =>
                  handleChangeChoosen(
                    "routeOfAdmin",
                    valueobj,
                    valueobj ? valueobj.id : ""
                  )
                }
                getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                value={chosenValues["routeOfAdmin"]}
                renderOption={(props, option) => (
                  <li {...props} key={option.id ?? option.name}>
                    <Typography className="sw_fontSize">{option.name}</Typography>
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    value={formData.routeOfAdmin}
                    label={
                      DispensingLanguage[lan][menukey]["Route of Admin"] + " *"
                    }
                    variant="standard"
                    error={!!errorObject.routeOfAdmin}
                    helperText={errorObject.routeOfAdmin}
                    id="routeOfAdmin"
                    name="routeOfAdmin"
                    fullWidth
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={4} sm={3}>
            <FormControl className={classes.fullWidth}>
              {formData.atc !== "" && (
                <Autocomplete
                  autoHighlight
                  disabled={!!props.permissionType}
                  id="atc"
                  options={ATC_List}
                  onChange={(event, newValue) =>
                    handleATCChange(event, newValue)
                  }
                  getOptionLabel={(option) => option.id + " - " + option.name}
                  defaultValue={
                    ATC_List[
                      ATC_List.findIndex(
                        (atclist) => atclist.id == formData.atc
                      )
                    ]
                  }
                  renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                      <Typography className="sw_fontSize">
                        {option.id + " - " + option.name}
                      </Typography>
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={DispensingLanguage[lan][menukey]["ATC"]}
                      variant="standard"
                    />
                  )}
                />
              )}

              {formData.atc == "" && (
                <Autocomplete
                  autoHighlight
                  disabled={!!props.permissionType}
                  id="atc"
                  options={ATC_List}
                  onChange={(event, newValue) =>
                    handleATCChange(event, newValue)
                  }
                  getOptionLabel={(option) => option.id + " - " + option.name}
                  renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                      <Typography className="sw_fontSize">
                        {option.id + " - " + option.name}
                      </Typography>
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={DispensingLanguage[lan][menukey]["ATC"]}
                      variant="standard"
                    />
                  )}
                />
              )}
            </FormControl>
          </Grid>

          {/* New row */}
          <Grid item xs={4} sm={3}>
            <TextField variant="standard"
              disabled={!!props.permissionType}
              id="fin"
              name="fin"
              label={DispensingLanguage[lan][menukey]["FIN"]}
              value={formData.fin}
              fullWidth
              autoComplete="given-name"
              onChange={(e) => handleChange(e)}
            />
          </Grid>

          <Grid item xs={4} sm={3}>
            <Grid container spacing={3}>
              <Grid item xs={6} sm={6}>
                {/*  <FormControl className={classes.fullWidth}>
                  <InputLabel id="demo-simple-select-helper-label">
                    {DispensingLanguage[lan][menukey]["Pack Size"]}*
                  </InputLabel>
                  <Select
                    error={!!errorObject.packSize}
                    labelId="demo-simple-select-helper-label"
                    id="demo-simple-select-helper"
                    name="packSize"
                    value={formData.packSize}
                    fullWidth
                    onChange={(e) => handleChange(e)}
                  label={`${DispensingLanguage[lan][menukey]["Pack Size"]} *`}>
                    {PackSizelist.map((item, index) => {
                      return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                    })}
                  </Select>
                  <FormHelperText error={!!errorObject.packSize}>
                    {errorObject.packSize}
                  </FormHelperText>
                </FormControl> */}

                <FormControl className={classes.fullWidth}>
                  <Autocomplete
                    autoHighlight
                    disabled={!!props.permissionType}
                    id="packSize"
                    options={PackSizelist}
                    onChange={(event, valueobj) =>
                      handleChangeChoosen(
                        "packSize",
                        valueobj,
                        valueobj ? valueobj.id : ""
                      )
                    }
                    getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                    value={chosenValues["packSize"]}
                    renderOption={(props, option) => (
                      <li {...props} key={option.id ?? option.name}>
                        <Typography className="sw_fontSize">{option.name}</Typography>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        value={formData.packSize}
                        label={
                          DispensingLanguage[lan][menukey]["Pack Size"] + " *"
                        }
                        variant="standard"
                        error={!!errorObject.packSize}
                        helperText={errorObject.packSize}
                        id="packSize"
                        name="packSize"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={6} sm={6}>
                {/* <FormControl className={classes.fullWidth}>
                  <InputLabel id="demo-simple-select-helper-label">
                    {DispensingLanguage[lan][menukey]["Unit"]}*
                  </InputLabel>
                  <Select
                    error={!!errorObject.unit}
                    labelId="demo-simple-select-helper-label"
                    id="demo-simple-select-helper"
                    name="unit"
                    value={formData.unit}
                    fullWidth
                    onChange={(e) => handleChange(e)}
                  label={`${DispensingLanguage[lan][menukey]["Unit"]} *`}>
                    {Unitofmeasurelist.map((item, index) => {
                      return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                    })}
                  </Select>
                  <FormHelperText error={!!errorObject.unit}>
                    {errorObject.unit}
                  </FormHelperText>
                </FormControl> */}

                <FormControl className={classes.fullWidth}>
                  <Autocomplete
                    autoHighlight
                    disabled={!!props.permissionType}
                    id="unit"
                    options={Unitofmeasurelist}
                    onChange={(event, valueobj) =>
                      handleChangeChoosen(
                        "unit",
                        valueobj,
                        valueobj ? valueobj.id : ""
                      )
                    }
                    getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                    value={chosenValues["unit"]}
                    renderOption={(props, option) => (
                      <li {...props} key={option.id ?? option.name}>
                        <Typography className="sw_fontSize">{option.name}</Typography>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        value={formData.unit}
                        label={DispensingLanguage[lan][menukey]["Unit"] + " *"}
                        variant="standard"
                        error={!!errorObject.unit}
                        helperText={errorObject.unit}
                        id="unit"
                        name="unit"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={4} sm={3}>
            <TextField variant="standard"
              disabled={!!props.permissionType}
              id="markUp"
              name="markUp"
              label={DispensingLanguage[lan][menukey]["Markup%"]}
              value={formData.markUp}
              fullWidth
              // type="number"
              autoComplete="given-name"
              onChange={(e) => handleChange(e)}
            />
          </Grid>

          <Grid item xs={4} sm={3}>
            <TextField variant="standard"
              disabled={!!props.permissionType}
              id="SellingPrice"
              name="SellingPrice"
              label={DispensingLanguage[lan][menukey]["Selling Price (CFA)"]}
              value={formData.SellingPrice}
              type="number"
              fullWidth
              autoComplete="given-name"
              onChange={(e) => handleChange(e)}
            />
          </Grid>

          {/* New row */}

          {/* <Grid item xs={4} sm={3}>
              <FormControl
                className="sw_radiogroup"
                component="fieldset"
                //required
                //error={!!errorObject.ProductTypeId}
                //helperText={errorObject.ProductTypeId}
              >
                <FormLabel component="legend">
                  {DispensingLanguage[lan][menukey]["Product Type"]}
                </FormLabel>
                <RadioGroup
                  column // change row to column
                  aria-label="ProductTypeId"
                  name="ProductTypeId"
                  //value={formData.ProductTypeId}
                  value={formData.ProductTypeId.toString()}
                  onChange={handleChange}
                >
                  {ProductTypeLocal.map((item, index) => {
                    return (
                      <FormControlLabel
                        //key={item.id.toString()}
                        value={item.id.toString()}
                        control={<Radio />}
                        label={item.name}
                      />
                    );
                  })}
                </RadioGroup>
              </FormControl>
            </Grid> */}

          {/* <Grid item xs={4} sm={3}>
            <FormControl component="fieldset">
              <FormLabel component="legend">
                {DispensingLanguage[lan][menukey]["Product Type"]}
              </FormLabel>

              <RadioGroup
                  aria-label="ProductTypeId"
                  name="ProductTypeId"
                  value="1"
                  className="sw_radiogroup"
                >
                  <FormControlLabel
                    value="1"
                    checked={formData.ProductTypeId == 1}
                    control={<Radio />}
                    label={DispensingLanguage[lan][menukey]["Drug Non ARV"]}
                    onChange={(e) => handleChange(e)}
                  />

                  <FormControlLabel
                    value="5"
                    checked={formData.ProductTypeId == 5}
                    control={<Radio />}
                    label={DispensingLanguage[lan][menukey]["Drug"]}
                    onChange={(e) => handleChange(e)}
                  />

                  <FormControlLabel
                    value="2"
                    checked={formData.ProductTypeId == 2}
                    control={<Radio />}
                    label={DispensingLanguage[lan][menukey]["Medical Supply"]}
                    onChange={(e) => handleChange(e)}
                  />
                    <FormControlLabel
                    value="4"
                    checked={formData.ProductTypeId == 4}
                    control={<Radio />}
                    label={DispensingLanguage[lan][menukey]["OI Medicine"]}
                    onChange={(e) => handleChange(e)}
                  />
                  <FormControlLabel
                    value="3"
                    checked={formData.ProductTypeId == 3}
                    control={<Radio />}
                    label={DispensingLanguage[lan][menukey]["Others"]}
                    onChange={(e) => handleChange(e)}
                  />
                </RadioGroup> 
            </FormControl>
          </Grid>  */}

          <Grid item xs={4} sm={3}>
            <FormControl component="fieldset">
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={!!props.permissionType}
                    color="primary"
                    checked={formData.bPediatric}
                    onChange={(e) => handleCheck(e)}
                    name="bPediatric"
                    value="no"
                  />
                }
                label={DispensingLanguage[lan][menukey]["Pediatric"]}
              />

              <FormControlLabel
                control={
                  <Checkbox
                    disabled={!!props.permissionType}
                    color="primary"
                    checked={formData.bInjectable}
                    onChange={(e) => handleCheck(e)}
                    name="bInjectable"
                    value="no"
                  />
                }
                label={DispensingLanguage[lan][menukey]["Injectable"]}
              />

              <FormControlLabel
                control={
                  <Checkbox
                    disabled={!!props.permissionType}
                    color="primary"
                    checked={formData.bKeyItem}
                    onChange={(e) => handleCheck(e)}
                    name="bKeyItem"
                    value="no"
                  />
                }
                label={DispensingLanguage[lan][menukey]["Key Product"]}
              />
            </FormControl>
          </Grid>

          <Grid item xs={4} sm={3}>
            <Grid item xs={12}>
              {/* <FormControl className={classes.fullWidth}>
                <InputLabel id="demo-simple-select-helper-label">
                  {DispensingLanguage[lan][menukey]["Administration Unit"]}*
                </InputLabel>
                <Select
                  error={!!errorObject.administrationUnit}
                  labelId="demo-simple-select-helper-label"
                  id="demo-simple-select-helper"
                  name="administrationUnit"
                  value={formData.administrationUnit}
                  fullWidth
                  onChange={(e) => handleChange(e)}
                label={`${DispensingLanguage[lan][menukey]["Administration Unit"]} *`}>
                  {Unitofmeasurelist.map((item, index) => {
                    return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                  })}
                </Select>
                <FormHelperText error={!!errorObject.administrationUnit}>
                  {errorObject.administrationUnit}
                </FormHelperText>
              </FormControl> */}

              <FormControl className={classes.fullWidth}>
                <Autocomplete
                  autoHighlight
                  disabled={!!props.permissionType}
                  id="administrationUnit"
                  options={Unitofmeasurelist}
                  onChange={(event, valueobj) =>
                    handleChangeChoosen(
                      "administrationUnit",
                      valueobj,
                      valueobj ? valueobj.id : ""
                    )
                  }
                  getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                  value={chosenValues["administrationUnit"]}
                  renderOption={(props, option) => (
                    <li {...props} key={option.id ?? option.name}>
                      <Typography className="sw_fontSize">{option.name}</Typography>
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      value={formData.administrationUnit}
                      label={
                        DispensingLanguage[lan][menukey][
                          "Administration Unit"
                        ] + " *"
                      }
                      variant="standard"
                      error={!!errorObject.administrationUnit}
                      helperText={errorObject.administrationUnit}
                      id="pacadministrationUnitkSize"
                      name="administrationUnit"
                      fullWidth
                    />
                  )}
                />
              </FormControl>
            </Grid>
            {/*  <Grid item xs={12} className="marginTop10">
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={formData.bPediatric}
                    onChange={(e) => handleCheck(e)}
                    name="bPediatric"
                    value="no"
                  />
                }
                label={DispensingLanguage[lan][menukey]["Pediatric"]}
              />

              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={formData.bInjectable}
                    onChange={(e) => handleCheck(e)}
                    name="bInjectable"
                    value="no"
                  />
                }
                label={DispensingLanguage[lan][menukey]["Injectable"]}
              />
            </Grid> */}
          </Grid>

          <Grid item xs={4} sm={3}>
            <Grid item xs={12}>
              <div className="sw_overlay_text">
                <TextField variant="standard"
                  disabled={!!props.permissionType}
                  id="shippingPack"
                  name="shippingPack"
                  type="number"
                  label={DispensingLanguage[lan][menukey]["Shipping Pack"]}
                  value={formData.shippingPack}
                  fullWidth
                  autoComplete="given-name"
                  onChange={(e) => handleChange(e)}
                />
                <span className="sw_pack_size">
                  {getPricebesideLevel("shippingPack")}
                </span>
              </div>
            </Grid>
            {/* <Grid item xs={12} className="marginTop10">
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={formData.bKeyItem}
                    onChange={(e) => handleCheck(e)}
                    name="bKeyItem"
                    value="no"
                  />
                }
                label={DispensingLanguage[lan][menukey]["Key Product"]}
              />
            </Grid> */}
          </Grid>

          {/* <Grid item xs={4} sm={3}>
            <div className="sw_overlay_text">
              <TextField variant="standard"
                id="shippingPack"
                name="shippingPack"
                type="number"
                label={DispensingLanguage[lan][menukey]["Shipping Pack"]}
                value={formData.shippingPack}
                fullWidth
                autoComplete="given-name"
                onChange={(e) => handleChange(e)}
              />
              <span className="sw_pack_size">
                {getPricebesideLevel("shippingPack")}
              </span>
            </div>
          </Grid> */}

          <Grid item xs={4} sm={3}>
            <FormControl variant="standard" className={classes.fullWidth}>
              <InputLabel id="demo-simple-select-helper-label">
                {DispensingLanguage[lan][menukey]["Type"]}*
              </InputLabel>
              <Select
                disabled={!!props.permissionType}
                error={!!errorObject.productType}
                labelId="demo-simple-select-helper-label"
                id="demo-simple-select-helper"
                name="productType"
                value={formData.productType}
                fullWidth
                onChange={(e) => handleChange(e)}
              label={`${DispensingLanguage[lan][menukey]["Type"]} *`}>
                {ProductTypeList.map((item, index) => {
                  return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                })}
              </Select>
              <FormHelperText error={!!errorObject.productType}>
                {errorObject.productType}
              </FormHelperText>
            </FormControl>
          </Grid>

          {/* new row */}
          <Grid item xs={12} sm={12} className="dnone">
            <FormControl component="fieldset" className={classes.formControl}>
              <FormGroup className="sw_Checkboxgroup">
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={!!props.permissionType}
                      color="primary"
                      checked={formData.bIncludeTrade}
                      onChange={(e) => handleCheck(e)}
                      name="bIncludeTrade"
                      value="no"
                    />
                  }
                  label={
                    DispensingLanguage[lan][menukey][
                      "Include Trade name in Description"
                    ]
                  }
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={!!props.permissionType}
                      color="primary"
                      checked={formData.bExcludeGeneric}
                      onChange={(e) => handleCheck(e)}
                      name="bExcludeGeneric"
                      value="no"
                    />
                  }
                  label={
                    DispensingLanguage[lan][menukey][
                      "Exclude Generic name from Description"
                    ]
                  }
                />
              </FormGroup>
            </FormControl>
          </Grid>

          {/* new row TAB */}

          {/*
          <Grid item xs={12} sm={12}>
            <div className={classes.root}>
              <AppBar position="static" color="default">
                <Tabs
                  value={value}
                  onChange={tabChangeHandler}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="scrollable auto tabs example"
                >
                  <Tab
                    label={DispensingLanguage[lan][menukey]["Dispensing"]}
                    {...a11yProps(0)}
                  />
                </Tabs>
              </AppBar>

              <SwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={value}
                onChangeIndex={handleChangeIndex}
              >
                <TabPanel value={value} index={0}>
                  <Grid container spacing={3}>
                    <Grid item xs={6} sm={6}>
                      <Card className="sw_card">
                        <CardHeader
                          title={
                            DispensingLanguage[lan][menukey][
                              "Packing Information"
                            ]
                          }
                        />
                        <CardContent>
                          <Grid container spacing={3}>
                            <Grid item xs={6} sm={6}>
                              <Typography variant="body2" component="p">
                                {DispensingLanguage[lan][menukey]["Strenght"]}
                              </Typography>
                            </Grid>
                            <Grid item xs={6} sm={6}>
                              <Typography
                                className={classes.pos}
                                color="textSecondary"
                              >
                                10mg/1ml
                              </Typography>
                            </Grid>

                            <Grid item xs={6} sm={6}>
                              <Typography variant="body2" component="p">
                                {
                                  DispensingLanguage[lan][menukey][
                                    "Strength Unit"
                                  ]
                                }
                              </Typography>
                            </Grid>
                            <Grid item xs={6} sm={6}>
                              <Typography
                                className={classes.pos}
                                color="textSecondary"
                              >
                                ml
                              </Typography>
                            </Grid>

                            <Grid item xs={6} sm={6}>
                              <Typography variant="body2" component="p">
                                {DispensingLanguage[lan][menukey]["Pack Size"]}
                              </Typography>
                            </Grid>
                            <Grid item xs={6} sm={6}>
                              <Typography
                                className={classes.pos}
                                color="textSecondary"
                              >
                                240ml
                              </Typography>
                            </Grid>

                            <Grid item xs={6} sm={6}>
                              <Typography variant="body2" component="p">
                                {
                                  DispensingLanguage[lan][menukey][
                                    "Dispening Pack Unit"
                                  ]
                                }
                              </Typography>
                            </Grid>
                            <Grid item xs={6} sm={6}>
                              <Typography
                                className={classes.pos}
                                color="textSecondary"
                              >
                                240ml
                              </Typography>
                            </Grid>

                            <Grid item xs={6} sm={6}>
                              <Typography variant="body2" component="p">
                                {DispensingLanguage[lan][menukey]["Rx Level"]}
                              </Typography>
                            </Grid>
                            <Grid item xs={6} sm={6}>
                              <Typography
                                className={classes.pos}
                                color="textSecondary"
                              >
                                240ml
                              </Typography>
                            </Grid>

                            <Grid item xs={6} sm={6}>
                              <Typography variant="body2" component="p">
                                {
                                  DispensingLanguage[lan][menukey][
                                    "Strength Co-efficient"
                                  ]
                                }
                              </Typography>
                            </Grid>
                            <Grid item xs={6} sm={6}>
                              <Typography
                                className={classes.pos}
                                color="textSecondary"
                              >
                                ml
                              </Typography>
                            </Grid>

                            <Grid item xs={6} sm={6}>
                              <Typography variant="body2" component="p">
                                {
                                  DispensingLanguage[lan][menukey][
                                    "Pack Co-efficient"
                                  ]
                                }
                              </Typography>
                            </Grid>
                            <Grid item xs={6} sm={6}>
                              <Typography
                                className={classes.pos}
                                color="textSecondary"
                              >
                                ml
                              </Typography>
                            </Grid>

                            <Grid item xs={6} sm={6}>
                              <Typography variant="body2" component="p">
                                {
                                  DispensingLanguage[lan][menukey][
                                    "Dispensing Unit"
                                  ]
                                }
                              </Typography>
                            </Grid>
                            <Grid item xs={6} sm={6}>
                              <Typography
                                className={classes.pos}
                                color="textSecondary"
                              >
                                Tablet
                              </Typography>
                            </Grid>

                            <Grid item xs={6} sm={6}>
                              <Typography variant="body2" component="p">
                                {
                                  DispensingLanguage[lan][menukey][
                                    "Administrative Form"
                                  ]
                                }
                              </Typography>
                            </Grid>
                            <Grid item xs={6} sm={6}>
                              <Typography
                                className={classes.pos}
                                color="textSecondary"
                              >
                                Tablet
                              </Typography>
                            </Grid>

                            <Grid item xs={6} sm={6}>
                              <Typography variant="body2" component="p">
                                {
                                  DispensingLanguage[lan][menukey][
                                    "Administrative Mode"
                                  ]
                                }
                              </Typography>
                            </Grid>
                            <Grid item xs={6} sm={6}>
                              <Typography
                                className={classes.pos}
                                color="textSecondary"
                              >
                                Tablet
                              </Typography>
                            </Grid>

                            <Grid item xs={12} sm={12}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    color="primary"
                                    checked={formData.availableforDispensing}
                                    onChange={(e) => handleCheck(e)}
                                    name="availableforDispensing"
                                    value="no"
                                  />
                                }
                                label={
                                  DispensingLanguage[lan][menukey][
                                    "Available for Dispensing"
                                  ]
                                }
                              />
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>

                    <Grid item xs={6} sm={6}>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        className="sw_fullWidth_hidden"
                      >
                        <Button
                          className="mb-3 float-end"
                          variant="contained"
                          color="primary"
                          onClick={() => ValidateProductForDispensing()}
                        >
                          {
                            DispensingLanguage[lan][menukey][
                              "Validate product for dispensing"
                            ]
                          }
                        </Button>
                      </Grid>
                      <Card className="sw_card">
                        <CardHeader
                          title={
                            DispensingLanguage[lan][menukey]["Label Display"]
                          }
                        />
                        <CardContent>
                          <Grid container spacing={3}>
                            <Grid item xs={4} sm={4}>
                              <Typography variant="body2" component="p">
                                {
                                  DispensingLanguage[lan][menukey][
                                    "Label Display"
                                  ]
                                }
                              </Typography>
                            </Grid>
                            <Grid item xs={4} sm={4}>
                              <Typography
                                className={classes.pos}
                                color="textSecondary"
                              >
                                10mg/1ml
                              </Typography>
                            </Grid>

                            <Grid item xs={4} sm={4}></Grid>

                            <Grid item xs={4} sm={4}>
                              <Typography variant="body2" component="p">
                                {
                                  DispensingLanguage[lan][menukey][
                                    "Lookup Display"
                                  ]
                                }
                              </Typography>
                            </Grid>
                            <Grid item xs={4} sm={4}>
                              <Typography
                                className={classes.pos}
                                color="textSecondary"
                              >
                                ml
                              </Typography>
                            </Grid>
                            <Grid item xs={4} sm={4}></Grid>

                            <Grid item xs={12} sm={12}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    color="primary"
                                    checked={formData.breakAdministrationUnit}
                                    onChange={(e) => handleCheck(e)}
                                    name="breakAdministrationUnit"
                                    value="no"
                                  />
                                }
                                label={
                                  DispensingLanguage[lan][menukey][
                                    "Break Administration Unit"
                                  ]
                                }
                              />
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </TabPanel>
              </SwipeableViews>
            </div>
          </Grid>*/}

          {/* {addProductForm ? (
            <Grid item xs={12} className="mt-4 text-center">
              <Button
                className="me-2"
                variant="contained"
                color="gray"
                type="reset"
                onClick={() => handleReset()}
              >
                {DispensingLanguage[lan][menukey]["Reset"]}
              </Button>
              <Button
                className="me-2"
                variant="contained"
                color="primary"
                onClick={() => handleSubmit()}
              >
                {DispensingLanguage[lan][menukey]["Save"]}
              </Button>
              <Button
                className="me-2"
                variant="contained"
                color="gray"
                type="reset"
                onClick={() => props.history.push("/products")}
              >
                {DispensingLanguage[lan][menukey]["Cancel"]}
              </Button>
            </Grid>
          ) : (
            <Grid item xs={12} className="mt-2 text-center">
              <Button
                className="me-2"
                variant="contained"
                color="primary"
                onClick={() => handleUpdate()}
              >
                {DispensingLanguage[lan][menukey]["Update"]}
              </Button>
              <Button
                className="me-2"
                variant="contained"
                color="gray"
                type="reset"
                onClick={() => props.history.push("/products")}
              >
                {DispensingLanguage[lan][menukey]["Cancel"]}
              </Button>
            </Grid>
          )} */}
        </Grid>
      </div>
    </div>
  );
};

export default ProductFormData;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
});
